import { createApp } from 'vue';
import {
  Button,
  Card,
  Empty,
  Form,
  Input,
  Table,
  message,
} from 'ant-design-vue';
import dayjs from 'dayjs';
import 'ant-design-vue/dist/reset.css';
import './styles.css';
import { createPublicPage } from './pages/public-page.js';
import { createAdminPage } from './pages/admin-page.js';
import { createConditionsPage } from './pages/conditions-page.js';

const container = document.getElementById('app');
const page = container?.dataset.page ?? 'public';

const pages = {
  public: createPublicPage({ message }),
  admin: createAdminPage({ dayjs, message }),
  conditions: createConditionsPage(),
};

const app = createApp(pages[page] ?? pages.public);
app.use(Button);
app.use(Card);
app.use(Empty);
app.use(Form);
app.use(Input);
app.use(Table);
app.mount('#app');
